export default __webpack_public_path__ + "locales/pl/Files.json?hash=9f4e8916df97cdd5e9a0649b29aa51f7";